import { render, staticRenderFns } from "./videodeurbelinbraakonderzoekBedankt.vue?vue&type=template&id=3433df96"
import script from "./videodeurbelinbraakonderzoekBedankt.vue?vue&type=script&lang=js"
export * from "./videodeurbelinbraakonderzoekBedankt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports